import { Dispatch } from '../../../../types'

/**
 *  Action Constants
 */
export const HandleOpenModal = 'Monitoring/Alerts/AdvancedAlertModal/HandleOpen'
export const HandleCloseModal = 'Monitoring/Alerts/AdvancedAlertModal/HandleClose'

/**
 *  Action Type
 */
export type HandleOpenModalAction = {
  type: 'Monitoring/Alerts/AdvancedAlertModal/HandleOpen'
}

export type HandleCloseModalAction = {
  type: 'Monitoring/Alerts/AdvancedAlertModal/HandleClose'
}

/**
 *  Action Creators
 */
export const handleOpenModal = (): HandleOpenModalAction => ({
  type: HandleOpenModal
})

export const handleCloseModal = (): HandleCloseModalAction => ({
  type: HandleCloseModal
})

export const handleOpen = () => (dispatch: Dispatch) => {
  dispatch(handleOpenModal())
}

export const handleClose = () => (dispatch: Dispatch) => {
  dispatch(handleCloseModal())
}

export type AdvancedAlertModalActions =
  | HandleOpenModalAction
  | HandleCloseModalAction
